<div id="login-form">


  <div *ngIf="loginErrorTranslation$ | async" class="usabilla-dont-show nes-w-full lg:nes-w-8/12 nes-my-8">
    <nes-message-bar
      id="loginError"
      nesId="message"
      data-pw="message"
      type="error"
      icon="alert"
      close="true"
      (nesOnCloseClick)="onCloseMessage()"
    >
      <nes-text color="red">
        {{ loginErrorTranslation$ | async }}
      </nes-text>

    </nes-message-bar>
  </div>

  <ng-container *ngIf="loginForm$ | async as form">
    <form class="nes-flex-col new-w-full md:nes-w-5/12" [formGroup]="form" (ngSubmit)="login(form)" method="#">
      <div class="login-form__label-container nes-mb-2">
        <nes-text color="blue" weight="bold" class="nes-text-base nes-text-blue nes-font-bold">{{
          (placeHolderTranslation$ | async) ? (placeHolderTranslation$ | async) : ''
        }}</nes-text>
      </div>
      <div class="nes-mb-8">
        <div
          class="nes-px-1 lg:nes-px-5 nes-mb-2 nes-border nes-bg-form-bg nes-border-form-border nes-rounded hover:nes-border-form-border-pressed {{
            (credentialErrorMessage$ | async) ? 'input-error' : ''
          }}"
        >
          <input
            #credentialInput
            data-pw="login-form__credential"
            id="credential"
            formControlName="credential"
            [type]="(accountType$ | async) === 'kaarthouder' ? 'email' : 'text'"
            class="nes-w-full nes-h-12 nes-px-0 nes-border-transparent nes-text-lg nes-transition nes-text-form-val lg:nes-h-14 focus:nes-outline-none nes-appearance-none nes-rounded placeholder:nes-font-normal placeholder:nes-leading-normal placeholder:nes-text-form-placeholder"
            (blur)="this.checkCredentials(form)"
            (change)="this.checkCredentials(form)"
            (keydown.enter)="onKeyDown(form, $event)"
          />
        </div>
        <ng-container *ngIf="this.credentialErrorMessage$ | async">
          <div class="nes-flex nes-items-center nes-mb-4">
            <nes-icon name="alert" color="red"></nes-icon>
            <nes-text color="red" class="error nes-px-2 nes-transition">
              {{ this.credentialErrorMessage$ | async }}
            </nes-text>
          </div>
        </ng-container>
      </div>
      <div class="login-form__label-container nes-mb-2 nes-flex nes-justify-between nes-relative">
        <nes-text color="blue" weight="bold" class="nes-text-base nes-text-blue nes-font-bold">{{ 'LOGIN.AUTH.PASSWORD' | translate }}</nes-text>
        <div
          class="nes-absolute nes-z-raised nes-top-0 nes-right-0 nes-h-8 nes-justify-self-end nes-flex nes-items-center nes-border-transparent nes-bg-transparent nes-cursor-pointer nes-text-cta-default nes-text-sm nes-fill-current nes-leading-normal focus:nes-outline-none before:nes-absolute before:nes--inset-x-2 before:nes-inset-y-0 before:nes-transition before:nes-rounded focus:before:nes-ring-inset focus:nes-ring-1 focus:nes-border-focus-default"
          (click)="this.togglePassWord()"
        >
          <nes-icon
            class="nes-mr-2 nes-mt-px"
            nes-aria-hidden="true"
            [name]="this.showPassword ? 'eye-crossed' : 'eye'"
          ></nes-icon>
          <span>
            {{
              this.showPassword ? ('LOGIN.AUTH.HIDE_PASSWORD' | translate) : ('LOGIN.AUTH.SHOW_PASSWORD' | translate)
            }}
          </span>
        </div>
      </div>
      <div
        class="nes-px-1 lg:nes-px-5 nes-mb-2 nes-border nes-border-form-border nes-rounded hover:nes-border-form-border-pressed focus:nes-border-focus-default
        {{ (passwordErrorMessage$ | async) ? 'input-error' : '' }}"
      >
        <input
          #passwordInput
          data-pw="login-form__password"
          id="password"
          [type]="this.showPassword ? 'text' : 'password'"
          formControlName="password"
          class="nes-w-full nes-h-12 nes-px-0 nes-border-transparent nes-text-lg nes-transition nes-text-form-val lg:nes-h-14 focus:nes-outline-none nes-appearance-none nes-rounded placeholder:nes-font-normal placeholder:nes-leading-normal placeholder:nes-text-form-placeholder"
          (blur)="this.checkPassword(form)"
          (change)="this.checkPassword(form)"
          (keydown.enter)="onKeyDown(form, $event)"
        />
      </div>
      <ng-container *ngIf="this.passwordErrorMessage$ | async">
        <div class="nes-flex nes-items-center nes-mb-4">
          <nes-icon name="alert" color="red"></nes-icon>
          <nes-text color="red" class="error nes-px-2 nes-w-full nes-transition">
            {{ this.passwordErrorMessage$ | async }}
          </nes-text>
        </div>
      </ng-container>
      <div class="login-form__link-container nes-mb-8 nes-flex nes-justify-between">
        <nes-link
          data-pw="login-form__link-to-forgot-credentials"
          class="nes-mt-8"
          stand-alone
          (click)="this.lostCredentials(form)"
          relay42
        >
          {{ 'LOGIN.AUTH.FORGOT_LOGIN' | translate }}
        </nes-link>
      </div>

      <div class="nes-flex-col nes-mb-8">
        <nes-button
          data-pw="login-form__submit-button"
          width-auto="true"
          variant="primary"
          type="submit"
          (nesOnClick)="login(form)"
          [loading]="loading$ | async"
        >
          <p class="nes-bold nes-text-base">
            {{ 'LOGIN.AUTH.LOGIN' | translate }}
          </p>
        </nes-button>
        <div
          id="recaptcha"
          class="g-recaptcha"
          data-sitekey="6LfTLnwqAAAAAAzpWZOHUShPqvBboDigSjNNvfG4"
          data-callback="getResponceCapcha"
          data-badge="bottom-rigth"
          data-size="invisible"
        ></div>
      </div>
    </form>
  </ng-container>
</div>
